import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { CalendarService } from '../services/calender-service';

@Pipe({
  name: 'persianDateTime',
})
export class PersianDateTimePipe implements PipeTransform {
  constructor(
    private calendarService: CalendarService
  ) {}

  transform(value: any): string {
    if (typeof value === 'string') {
      const regexPattern: RegExp =
        /\d{4}(-|\/)\d{2}(-|\/)\d{2}(T| )\d{2}:\d{2}:\d{2}/;

      const isMatch: boolean = regexPattern.test(value);
      if (isMatch) {
        const pareDatePattern: RegExp =
          /(?<year>\d{4})(-|\/)(?<month>\d{2})(-|\/)(?<day>\d{2})(T| )(?<time>\d{2}:\d{2}):\d{2}/;
        const testParseDatePattern: boolean = pareDatePattern.test(value);
        if (testParseDatePattern) {
          const groups = value.match(pareDatePattern)?.groups;
          const year: number = Number(groups?.['year']);
          const month: number = Number(groups?.['month']);
          const day: number = Number(groups?.['day']);
          const time = groups?.['time'];
          const persianDate = this.calendarService.ToPersianDateTime(value);
          return `${time} ${persianDate.year}/${persianDate.month}/${persianDate.day}`;
        }
      }
    }
    return '--';
  }
}
